/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Rule } from "../../../models/rule";
import { RuleCondition, Operator, OperatorUtil } from "../../../models/rule-condition";
import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: 'app-rule-parameter-editor',
  templateUrl: './rule-parameter-editor.component.html'
})
export class RuleParameterEditorComponent implements OnInit {
  
    @Input()
    rule: Rule;
      
    @Input()
    ruleCondition: RuleCondition;
    
    operators: Operator[] = [];
  
    showBody: boolean = false;
    
    ngOnInit(): void {
        if (this.ruleCondition != null && this.ruleCondition.propertyType != null) {
            this.operators = OperatorUtil.getOperatorsForPropertyType(this.ruleCondition.propertyType);
        } else {
            this.operators = [ Operator.EQUAL, Operator.NOT_EQUAL ];
        }

        
        this.showBody = this.ruleCondition != null && this.ruleCondition.id != null ? false : true; 
    }
    
    getValueLabel(): string {
        return this.ruleCondition.value;
    }
    
    getOperatorLabel(operator: Operator): string {
        if (operator == null) {
            return "*UNKNOWN-OPERATOR*";
        } else {
            return OperatorUtil.getOperatorLabel(operator);
        }
    }

    getParameterLabel(): string {
        if (this.rule != null && this.rule.event != null && this.rule.event.properties != null) {
            const property = this.rule.event.properties.find(p => p.property == this.ruleCondition.property);
            return property != null ? property.name : "?";
        } else {
            return "?";
        }
    }
    
    onRemove(event, value): void {
        const index = this.rule.conditions.indexOf(value);
        
        if (index > -1) {
            this.rule.conditions.splice(index, 1);
        }
    }
}
